import { Badge } from "@/components/ui/Badge";
import { Card, CardContent } from "@/components/ui/Card";
import { Sheet, SheetContent } from "@/components/ui/Sheet";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/Table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/Tabs";
import { TicketAction, TicketActionOnStatus, TicketStatus, useGetAllListingOfTicketsQuery, useGetTicketAuditDetailQuery, useUpdateAssignedToMutation, useUpdateLinkedTicketMutation, useUpdateTicketStatusMutation, useUpdateTitleMutation } from "@/services/LiveQueueService";
import { calculateWaitingTime, formatPhoneNumber, formatTime, getStatusColor } from "@/utils/Helper";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select";
import { FormField } from "@/components/ui/Form";
import { useForm } from "react-hook-form";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/MobileToolTip";
import { Ticket } from "@/app/types/tickets";
import { useMemo, useState, useEffect } from "react";
import { useGetAllTasksQuery } from "@/services/TasksApi";
import useTableData from "@/components/ui/table/DataTableLogic";
import { useGetStaffListQuery } from "@/services/StaffsApi";
import { Button } from "@/components/ui/Button";
import TicketEditForm from "./TicketDetailEdit";
import { MultiSelect } from "@/components/ui/multiselect/MultiSelectCheckBox";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { RootState } from "@/app/store";
import {DataTableRowActions} from "@/components/admin/tasks/component/table/DataTableRowAction";
import TaskForm from "../../tasks/component/modal/TaskForm";
import { PlusCircle } from "lucide-react";
import { Task, TaskPriority, TaskStatus } from "@/app/types/tasks";
import { toast } from "@/components/ui/UseToast";
import { cn } from "@/lib/utils";
import { useDebounce } from "@/hooks/UseDebounce";
import LinkedTickets from "./LinkTicketAuditLog";
import CommentsSection from "./AuditDetailCommentSection";


// initial filter setting
const initialValue = {
  offset: 0,
  sort_order: "desc",
  sort_key: "id",
};
interface TicketDetails {
  isOpen: boolean;
  setOpen: any;
  ticketId: Number |undefined;
}

const DetailLogs = ({ isOpen, setOpen, ticketId }: TicketDetails) => {
  const [isLinkSheetOpen, setIsLinkSheetOpen] = useState(false);

  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const [currentlyEditing, setCurrentlyEditing] = useState<string | null>(null);
  const [selectedTicket, setSelectedTicket] = useState<Ticket>();
  const { data, isLoading, error, refetch } = useGetTicketAuditDetailQuery(
    ticketId as number,
    {
      skip: !isOpen || ticketId === undefined,
    }
  );
  

  const [isTaskFormOpen, setIsTaskFormOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<Task | undefined>(undefined);
  const [taskFormAction, setTaskFormAction] = useState<"add" | "edit">("add");
  const [taskLogsOpen, setTaskLogsOpen] = useState(false);
  const [taskLogId, setTaskLogId] = useState<number | undefined>();
  const viewkanban = (() => {
    try {
      return (
        JSON.parse(localStorage.getItem("accessLevels") as string).viewkanban ??
        "no_access"
      );
    } catch {
      return "no_access";
    }
  })();
  const userInfo = useSelector((state: RootState) => state.auth.userInfo);
  
  const [updateTitle] = useUpdateTitleMutation();
  const [updateStatus] = useUpdateTicketStatusMutation();
  const [updateAssignedTo] = useUpdateAssignedToMutation();
  // Add these with your other state declarations
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [editableDescription, setEditableDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [isSavingDescription, setIsSavingDescription] = useState(false);

  // Add these with your other state declarations
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editableTitle, setEditableTitle] = useState("");
  const [isSavingTitle, setIsSavingTitle] = useState(false);
  const [titleError, setTitleError] = useState("");

  const [isEditingStatus, setIsEditingStatus] = useState(false);
  const [editableStatus, setEditableStatus] = useState("");
  const [isSavingStatus, setIsSavingStatus] = useState(false);
  const [selectKey, setSelectKey] = useState(0);

  // Add with your other state variables
  const [isEditingAssignedStaff, setIsEditingAssignedStaff] = useState(false);
  const [editableAssignedStaff, setEditableAssignedStaff] = useState<string[]>(
    []
  );
  const [isSavingAssignedStaff, setIsSavingAssignedStaff] = useState(false);
  const [addLinkedTicket,{
    isLoading: isLinkingTicket,
  }] = useUpdateLinkedTicketMutation();

  const [searchQuery, setSearchQuery] = useState<string>("");
  const debouncedSearchQuery = useDebounce<string>(searchQuery, 500);
  const [selectedLinkTicket, setSelectedLinkTicket] = useState<any>(null);

  const queryString = useMemo(() => {
    const statuses = [
      TicketStatus.NO_SHOW,
      TicketStatus.IN_PROGRESS,
      TicketStatus.AWAITING_INFO,
      TicketStatus.HOLD,
      TicketStatus.CANCELLED,
      TicketStatus.COMPLETED,
    ];

    let baseQuery = `user_id=${data?.ticket_details?.customer.id || ""}`;
    // Dynamically append statuses
    const statusQuery = statuses.map((status) => `status=${status}`).join("&");

    // Append search query if it exists
    if (debouncedSearchQuery) {
      baseQuery += `&search=${debouncedSearchQuery}`;
    }

    return `${baseQuery}&${statusQuery}&limit=1000&offset=0`;
  }, [data?.ticket_details?.customer.id, debouncedSearchQuery]);

  const {
    data: tickets,
    isLoading: isLoadingTickets,
    refetch: refetchTickets,
  } = useGetAllListingOfTicketsQuery(
    {
      query: queryString,
    },
    {
      skip: !Boolean(data?.ticket_details?.customer.id) || !isLinkSheetOpen,
    }
  );

  const filteredTickets = useMemo(() => {
    if (!Array.isArray(tickets?.data)) return [];
    
    console.log("Filtered Tickets:", tickets.data.length);
    const ticket = tickets.data.filter(
      (ticket) =>
        (data?.ticket_details?.ticket_number !== ticket.ticket_number &&
          ticket.parent_ticket_id === null &&
          ticket.ticket_number.includes("S-")) ||
        ticket.ticket_number.includes("s-")

      // ticket.ticket_number.includes("S-"||"s-")
      // &&
      // ticket.ticket_id.includes("S-")
    );
    console.log("return length", ticket.length);
    return ticket;
  }, [tickets?.data, data?.ticket_details?.ticket_number]);

  const linkTicket = async () => {
    if (!selectedLinkTicket) return;
    
    try {
      await addLinkedTicket({
        action: TicketAction.LINK,
        ticket_id: Number(selectedLinkTicket.id),
        staff_id: String(userInfo?.id ?? 0),
        trigger_lambda: false,
        parentTicketId: Number(ticketId),
      }).unwrap();
      
      toast({
        title: "Success",
        description: "Ticket linked successfully",
      });
      
      // Refetch ticket details to update UI
      refetch();
      setSearchQuery("");
      setSelectedLinkTicket(null);
      setIsLinkSheetOpen(false);
    } catch (error) {
      console.error("Error linking ticket:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to link ticket",
      });
    }
  };

  useEffect(() => {
    if (isLinkSheetOpen && data?.ticket_details?.customer.id) {
      refetchTickets();
    }
  }, [isLinkSheetOpen, data?.ticket_details?.customer.id, refetchTickets]);

  const handleSaveAssignedStaff = async () => {
    try {
      setIsSavingAssignedStaff(true);
await      updateAssignedTo({
                ticketId: Number(ticketId),
                assigned_to: editableAssignedStaff || [],
                action: TicketAction.ASSIGNED_TO,
                staff_id: String(userInfo?.id ?? 0),
              }).unwrap(),
      // After successful save
      console.log("Assigned staff saved:", editableAssignedStaff);
      // Refetch data to update the UI with the latest changes
      await refetch();
      // Exit edit mode
      setIsEditingAssignedStaff(false);
      setCurrentlyEditing(null);
    } catch (error) {
      console.error("Failed to update assigned staff", error);
      // You can add error handling UI here if needed
    } finally {
      setIsSavingAssignedStaff(false);
    }
  };
  const isEditingAllowed = () => {
    const status = data?.ticket_details.status;
    // Don't allow editing for CANCELLED and ARCHIVED statuses
    return status !== "CANCELLED" && status !== "RESERVED" && status !== "ARCHIVED";
  };
  const handleSaveStatus = async () => {
    try {
      setIsSavingStatus(true);
      const validActions = [
        "COMPLETE",
        "HOLD",
        "ABSENT",
        "IN_PROGRESS",
        "AWAITING_INFO",
        "CHECKED_IN",
        "ARCHIVED",
        "ROUTE",
        "COMMENT",
        "UPDATE_USER",
        "UPDATE_DETAILS",
        "LINK",
        "ASSIGNED_TO",
      ];
        if (editableStatus && validActions.includes(editableStatus)) {
           await updateStatus({
              ticket_id: Number(ticketId),
              action: editableStatus as TicketAction,
              staff_id: String(userInfo?.id ?? 0),
              trigger_lambda: false,
            }).unwrap()
        } else if (editableStatus) {
          console.warn(
            `Invalid status value: ${editableStatus}. Status update skipped.`
          );
        }
      // After successful save
      console.log("Status saved:", editableStatus);

      // Refetch data to update the UI with the latest changes
      await refetch();

      // Exit edit mode
      setIsEditingStatus(false);
      setCurrentlyEditing(null);

    } catch (error) {
      console.error("Failed to update status", error);
      // You can add error handling UI here if needed
    } finally {
      setIsSavingStatus(false);
    }
  };
  const handleSaveTitle = async () => {
    if(titleError){
      toast({
        variant:"destructive",
        description: titleError,
      })
      return
    }
    try {
      setIsSavingTitle(true);
        await  updateTitle({
        action: TicketAction.UPDATE_DETAILS,
        ticketId: Number(ticketId),
        staff_id: String(userInfo?.id ?? 0),
        ticketData: {
          title: editableTitle,
          description: data?.ticket_details.description ?? "",
        },
      }).unwrap(),
      // After successful save
      console.log("Title saved:", editableTitle);

      // Refetch data to update the UI with the latest changes
      await refetch();

      // Exit edit mode
      setIsEditingTitle(false);
      setCurrentlyEditing(null);

    } catch (error) {
      console.error("Failed to update title", error);
      // You can add error handling UI here if needed
    } finally {
      setIsSavingTitle(false);
    }
  };

  const handleSaveDescription = async () => {
    if (descriptionError) {
      toast({
        variant: "destructive",
        description: descriptionError,
      });
      return;
    }
    try {
      setIsSavingDescription(true);
      // await new Promise((resolve) => setTimeout(resolve, 500));
      await updateTitle({
        action: TicketAction.UPDATE_DETAILS,
        ticketId: Number(ticketId),
        staff_id: String(userInfo?.id ?? 0),
        ticketData: {
          title: data?.ticket_details.title ?? "",
          description: editableDescription ?? "",
        },
      }).unwrap(),
        // After successful save
        console.log("Description saved:", editableDescription);

      // Refetch data to update the UI with the latest changes
      await refetch();

      // Exit edit mode
      setIsEditingDescription(false);
      setCurrentlyEditing(null);
    } catch (error) {
      console.error("Failed to update description", error);
      // You can add error handling UI here if needed
    } finally {
      setIsSavingDescription(false);
    }
  };

  const [showComments, setShowComments] = useState(true); // State for comments section
  const { searchCriteria, query, toggleSortOrder, setSearchCriteria } =
    useTableData(initialValue);
  const {
    data: TaskData,
    isLoading: isTaskDataLoading,
    isError,
    refetch:TaskRefetch
  } = useGetAllTasksQuery(
    { query: `${query}&ticket_id=${ticketId}` },
    {
      skip: query == "" || ticketId === undefined,
    }
  );

  const tableData = useMemo(() => {
    return Array.isArray(TaskData?.data) ? TaskData?.data : [];
  }, [TaskData?.data]);

  const { data: staffData } = useGetStaffListQuery({ query: "" });

  const handleOpenChange = (open: boolean) => {
    setOpen(open);
    if (open) {
      refetch();
    }
  };

  interface FormValues {
    status: string;
    staff_ids: string[];
  }
  
  const form = useForm<FormValues>({
    defaultValues: {
      status: data?.ticket_details.status || '',
      staff_ids: [], // Now properly typed as string[]
    },
  });

  const handleCreateTask = () => {
        const today = new Date();
        const localDate = today.toLocaleDateString("en-CA");
    setTaskFormAction("add");
    setSelectedTask({
          is_deleted: false,
          task_id: 0,
          created_by: "",
          updated_by: "",
          comments: [],
          title: "",
          description: "",
          status: TaskStatus.TODO,
          due_date: localDate, // Format date as YYYY-MM-DD
          priority: TaskPriority.LOW,
          assigned_to: "",
          created_at: new Date().toISOString(),
          attachments: [],
          tags: [],
          linked_ticket: {
            ticket_id: Number(data?.ticket_details?.id) || 0, // Convert to number and provide a default value of 0 if undefined
            ticket_number: data?.ticket_details?.ticket_number?.toString() || "",
            reserved_number: "",
            assigned_number: "",
          },
        });

    setIsTaskFormOpen(true);

  };

  const handleEditTask = (task: Task) => {
    setTaskFormAction("edit");
    setSelectedTask(task);
    setIsTaskFormOpen(true);
  };

  if (isLoading && isOpen) {
    return (
      <div className="p-4">
        <Sheet>
          <SheetContent className="!w-full !max-w-[900px] overflow-auto fancy-scrollbar">
            <div className="space-y-4">
              {/* Header skeleton with title and status */}
              <div className="flex items-center justify-between pt-3">
                <div className="w-64 h-7 bg-gray-200 animate-pulse rounded" />
                <div className="w-24 h-6 bg-gray-200 animate-pulse rounded-full" />
              </div>

              {/* Tabs Navigation skeleton */}
              <div className="w-full">
                <div className="flex flex-row justify-between items-center mb-1">
                  <div className="w-[80%] grid grid-cols-4 gap-2 h-10 bg-gray-100 rounded-md p-1">
                    {[1, 2, 3, 4].map((i) => (
                      <div
                        key={i}
                        className="bg-gray-200 animate-pulse rounded h-8"
                      />
                    ))}
                  </div>
                  <div className="w-10 h-10 bg-gray-200 animate-pulse rounded" />
                </div>

                {/* Main content skeleton */}
                <div className="space-y-4 mt-4">
                  {/* Yellow card skeleton */}
                  <div className="border rounded-md bg-amber-50/30 p-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      {[...Array(15)].map((_, i) => (
                        <div key={i} className="space-y-1">
                          <div className="w-32 h-4 bg-gray-200 animate-pulse rounded" />
                          <div className="w-40 h-5 bg-gray-200 animate-pulse rounded" />
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Description card skeleton */}
                  <div className="border rounded-md bg-amber-50/30 p-4">
                    <div className="w-32 h-5 bg-gray-200 animate-pulse rounded mb-2" />
                    <div className="space-y-2">
                      <div className="w-full h-4 bg-gray-200 animate-pulse rounded" />
                      <div className="w-4/5 h-4 bg-gray-200 animate-pulse rounded" />
                      <div className="w-3/5 h-4 bg-gray-200 animate-pulse rounded" />
                    </div>
                  </div>

                  {/* Comments section skeleton */}
                  <div className="space-y-2">
                    <div className="w-32 h-5 bg-gray-200 animate-pulse rounded" />
                    <div className="border rounded-md bg-amber-50/30 p-4">
                      <div className="space-y-4">
                        {[...Array(3)].map((_, i) => (
                          <div
                            key={i}
                            className="mb-3 pb-3 border-b last:border-0"
                          >
                            <div className="space-y-2">
                              <div className="w-full h-4 bg-gray-200 animate-pulse rounded" />
                              <div className="w-4/5 h-4 bg-gray-200 animate-pulse rounded" />
                            </div>
                            <div className="flex justify-between items-center mt-2">
                              <div className="w-24 h-3 bg-gray-200 animate-pulse rounded" />
                              <div className="w-32 h-3 bg-gray-200 animate-pulse rounded" />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    );
  }

  if (error) {
    return <div>Error loading ticket details</div>;
  }

  const handleEditTicket = (ticket: Ticket) => {
    setSelectedTicket(ticket);
    setIsSheetOpen(true);
  };
  const handleSaveTicket = async (updatedTicket: Ticket) => {
    // Implement your API call to save the ticket
    console.log("Saving ticket:", updatedTicket);
    // Example API call:
    // await updateTicket(updatedTicket);
    return true;
  };

  const handleRefetchData = () => {
    // Implement your data refetch logic
    console.log("Refetching tickets data");
  };
  return (
    <div>
      <Sheet open={isOpen} onOpenChange={handleOpenChange}>
        <SheetContent className="!w-full !max-w-[900px] overflow-auto fancy-scrollbar">
          <div className="space-y-4">
            {/* Header with title and status */}
            <div className="flex items-center justify-between pt-3">
              <div className="flex items-center max-w-[75%]">
                <h1 className="text-xl font-semibold mr-2">
                  Ticket Details -{" "}
                </h1>

                {isEditingTitle ? (
                  <div className="flex-1 flex items-center gap-2">
                    <div>
                      <input
                        type="text"
                        value={editableTitle}
                        onChange={(e) => {
                          const normalized = e.target.value
                            .replace(/\s+/g, " ")
                            .trim();
                          if (normalized.length <= 50) {
                            setEditableTitle(normalized);
                            setTitleError("");
                          } else {
                            setTitleError(
                              "Title must be 50 characters or less"
                            );
                          }
                        }}
                        className="p-1 border rounded-md text-sm font-semibold min-w-[200px]"
                        placeholder="Enter title..."
                        disabled={isSavingTitle}
                      />
                      {titleError && (
                        <p className="text-red-500 text-xs mt-1">
                          {titleError}
                        </p>
                      )}
                    </div>

                    <div className="flex gap-2">
                      <Button
                        size="sm"
                        variant={"outline"}
                        onClick={() => {
                          setIsEditingTitle(false);
                          setCurrentlyEditing(null);
                        }}
                        disabled={isSavingTitle}
                      >
                        Cancel
                      </Button>
                      <Button
                        size="sm"
                        variant={"outline"}
                        onClick={handleSaveTitle}
                        disabled={isSavingTitle}
                      >
                        {isSavingTitle ? (
                          <>
                            <i className="fa-solid fa-spinner fa-spin mr-2"></i>
                            Saving...
                          </>
                        ) : (
                          "Save"
                        )}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center">
                    <span className="text-xl font-semibold break-all">
                      {data?.ticket_details.title}
                    </span>
                    {!currentlyEditing && isEditingAllowed() && (
                      <Button
                        variant={"ghost"}
                        size="sm"
                        onClick={() => {
                          setIsEditingTitle(true);
                          setEditableTitle(data?.ticket_details.title || "");
                          setCurrentlyEditing("title");
                        }}
                        className="ml-2 text-gray-600 hover:text-gray-900"
                      >
                        <i className="fa-solid fa-pencil text-sm"></i>
                      </Button>
                    )}
                  </div>
                )}
              </div>

              {/* Status edit section */}
              {isEditingStatus ? (
                <div className="flex items-center gap-2">
                  <FormField
                    control={form.control}
                    name="status"
                    render={({ field }) => (
                      <Select
                        key={selectKey}
                        onValueChange={(value) => {
                          setEditableStatus(value);
                          field.onChange(value);
                        }}
                        value={editableStatus}
                      >
                        <SelectTrigger className="capitalize border-primary w-[180px] flex justify-between items-center px-4 py-2 border bg-background rounded-md shadow-sm">
                          <SelectValue>
                            {editableStatus
                              ? editableStatus === TicketAction.COMPLETE
                                ? "Complete"
                                : editableStatus
                                    .replace(/_/g, " ")
                                    .toLowerCase()
                              : "Select status"}
                          </SelectValue>
                        </SelectTrigger>
                        <SelectContent>
                          {Object.values(TicketActionOnStatus).map(
                            (action: string) => (
                              <SelectItem
                                key={action}
                                value={action}
                                className="text-start capitalize"
                              >
                                {action === TicketAction.COMPLETE
                                  ? "Complete"
                                  : action.replace(/_/g, " ").toLowerCase()}
                              </SelectItem>
                            )
                          )}
                        </SelectContent>
                      </Select>
                    )}
                  />
                  <div className="flex gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setIsEditingStatus(false);
                        setCurrentlyEditing(null);
                      }}
                      disabled={isSavingStatus}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={handleSaveStatus}
                      disabled={isSavingStatus}
                    >
                      {isSavingStatus ? (
                        <>
                          <i className="fa-solid fa-spinner fa-spin mr-2"></i>
                          Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="flex items-center">
                  <Badge
                    className={`${data?.ticket_details.status ? getStatusColor(data.ticket_details.status) : ""} text-white`}
                  >
                    {data?.ticket_details.status?.replace("_", " ")}
                  </Badge>
                  {!currentlyEditing && isEditingAllowed() && (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => {
                        setIsEditingStatus(true);
                        setEditableStatus(data?.ticket_details.status || "");
                        setCurrentlyEditing("status");
                      }}
                      className="ml-2 text-gray-600 hover:text-gray-900"
                    >
                      <i className="fa-solid fa-pencil text-sm"></i>
                    </Button>
                  )}
                </div>
              )}
            </div>

            {/* Tabs Navigation */}
            <Tabs defaultValue="details" className="w-full">
              <div className="flex flex-row justify-between items-center mb-1">
                <TabsList className="w-[80%] grid grid-cols-4">
                  <TabsTrigger value="details" variant={"primary"}>
                    Ticket Details
                  </TabsTrigger>
                  <TabsTrigger value="tasks" variant="primary">
                    Tasks {TaskData?.filtered_count}
                  </TabsTrigger>
                  <TabsTrigger value="linked" variant="primary">
                    Linked Tickets{" "}
                    {data?.ticket_details.parent_ticket_id
                      ? data?.ticket_details.child_tickets?.length
                      : ""}
                  </TabsTrigger>
                  <TabsTrigger value="logs" variant="primary">
                    Logs
                  </TabsTrigger>
                </TabsList>
              </div>

              {/* Ticket Details Tab Content */}
              <TabsContent value="details" className="space-y-4">
                <h2 className=" pb-2"></h2>
                {/* Main ticket information in yellow box */}
                <Card className="border rounded-md bg-amber-50">
                  <CardContent className="p-4 grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Ticket Number:
                      </p>
                      <p>{data?.ticket_details.ticket_id}</p>
                    </div>

                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Department:
                      </p>
                      <p className="max-w-48 break-all">
                        {data?.ticket_details.service.department_name}
                      </p>
                    </div>

                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Service:
                      </p>
                      <p>{data?.ticket_details.service.name}</p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        ITS Number:
                      </p>
                      <p>{data?.ticket_details.customer.username}</p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Customer Name:
                      </p>
                      <p>{data?.ticket_details.customer.name}</p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Phone Number:
                      </p>
                      <p>
                        {formatPhoneNumber(
                          data?.ticket_details.customer.phone_number || ""
                        )}
                      </p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500 ">
                        Email:
                      </p>
                      <p className="max-w-48 break-all">
                        {data?.ticket_details.customer.email}
                      </p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Counter:
                      </p>
                      <p>{data?.ticket_details.counter_id}</p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Serving Agent:
                      </p>
                      <p>{data?.ticket_details.serving_agent.name}</p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Waiting Time:
                      </p>
                      <p>
                        {data?.ticket_details.served_at
                          ? (() => {
                              const waitingMinutes = calculateWaitingTime(
                                data?.ticket_details.date,
                                data?.ticket_details.time,
                                data?.ticket_details.served_at
                              );
                              return waitingMinutes >= 60
                                ? `${Math.floor(waitingMinutes / 60)} hr${waitingMinutes % 60 !== 0 ? ` ${waitingMinutes % 60} min` : ""}`
                                : `${waitingMinutes} min`;
                            })()
                          : ""}
                      </p>
                    </div>

                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Appointment Date:
                      </p>
                      <p>
                        {data?.ticket_details.date
                          ? new Date(data?.ticket_details.date)
                              .toLocaleDateString("en-PK", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              })
                              .replace(/\//g, "-")
                          : ""}
                      </p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Appointment Time:
                      </p>
                      <p>{formatTime(data?.ticket_details.time || "")}</p>
                    </div>
                    <div className="space-y-1">
                      <div className="flex justify-start gap-6 items-center">
                        <p className="text-sm font-medium text-gray-500">
                          Assigned to:
                        </p>
                        {!isEditingAssignedStaff &&
                          !currentlyEditing &&
                          isEditingAllowed() && (
                            <Button
                              variant="ghost"
                              size="sm"
                              onClick={() => {
                                setIsEditingAssignedStaff(true);
                                const staffIds = Array.isArray(
                                  data?.ticket_details.assigned_staff
                                )
                                  ? data.ticket_details.assigned_staff.map(
                                      (staff) => staff.id.toString()
                                    )
                                  : [];
                                setEditableAssignedStaff(staffIds);
                                setCurrentlyEditing("assignedStaff");
                              }}
                              className="text-gray-600 hover:text-gray-900"
                            >
                              <i className="fa-solid fa-pencil text-sm"></i>
                            </Button>
                          )}
                      </div>

                      {isEditingAssignedStaff ? (
                        <div className="space-y-2">
                          <Controller
                            name="staff_ids"
                            control={form.control}
                            defaultValue={editableAssignedStaff}
                            render={({ field }) => (
                              <MultiSelect
                                options={
                                  staffData
                                    ? staffData.map((staff) => ({
                                        label: staff.label,
                                        value: staff.value,
                                      }))
                                    : []
                                }
                                defaultValue={editableAssignedStaff || []}
                                onValueChange={(selectedValues) => {
                                  const stringValues = selectedValues.map(
                                    (value) => String(value)
                                  );
                                  setEditableAssignedStaff(stringValues);
                                  field.onChange(selectedValues);
                                }}
                                placeholder="Select Staff"
                                variant="inverted"
                                maxCount={1}
                                className="focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 min-w-full"
                              />
                            )}
                          />
                          <div className="flex gap-2 mt-2">
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => {
                                setIsEditingAssignedStaff(false);
                                setCurrentlyEditing(null);
                              }}
                              disabled={isSavingAssignedStaff}
                            >
                              Cancel
                            </Button>
                            <Button
                              size="sm"
                              variant="outline"
                              onClick={handleSaveAssignedStaff}
                              disabled={isSavingAssignedStaff}
                            >
                              {isSavingAssignedStaff ? (
                                <>
                                  <i className="fa-solid fa-spinner fa-spin mr-2"></i>
                                  Saving...
                                </>
                              ) : (
                                "Save"
                              )}
                            </Button>
                          </div>
                        </div>
                      ) : (
                        Array.isArray(data?.ticket_details.assigned_staff) &&
                        data?.ticket_details.assigned_staff.map(
                          (staff, index) => (
                            <p key={index} className="capitalize">
                              {staff.name}
                            </p>
                          )
                        )
                      )}
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Created Date:
                      </p>
                      <p>
                        {data?.ticket_details.created_at
                          ? (() => {
                              const date = new Date(
                                `${data.ticket_details.created_at}Z`
                              );
                              const formattedDate = date
                                .toLocaleDateString("en-PK", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                })
                                .replace(/\//g, "-"); // dd-mm-yyyy
                              const formattedTime = date.toLocaleTimeString(
                                "en-GB",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              ); // hh:mm am/pm
                              return `${formattedDate} ${formattedTime}`;
                            })()
                          : ""}
                      </p>
                    </div>

                    <div className="space-y-1">
                      <p className="text-sm font-medium text-gray-500">
                        Last Updated:
                      </p>
                      <p>
                        {data?.ticket_details.updated_at
                          ? (() => {
                              const date = new Date(
                                `${data.ticket_details.updated_at}Z`
                              );
                              const formattedDate = date
                                .toLocaleDateString("en-PK", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                })
                                .replace(/\//g, "-"); // dd-mm-yyyy
                              const formattedTime = date.toLocaleTimeString(
                                "en-GB",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              ); // hh:mm am/pm
                              return `${formattedDate} ${formattedTime}`;
                            })()
                          : ""}
                      </p>
                    </div>
                  </CardContent>
                </Card>
                <Card className="border rounded-md bg-amber-50">
                  <CardContent className="p-4">
                    <div className="flex justify-between items-center mb-2">
                      <h3 className="font-medium">Description:</h3>
                      {!isEditingDescription &&
                      !currentlyEditing &&
                      isEditingAllowed() ? (
                        <Button
                          variant="ghost"
                          onClick={() => {
                            setIsEditingDescription(true);
                            setEditableDescription(
                              data?.ticket_details.description || ""
                            );
                            setCurrentlyEditing("description");
                          }}
                          className="text-gray-600 hover:text-gray-900"
                        >
                          <i className="fa-solid fa-pencil text-sm"></i>
                        </Button>
                      ) : isEditingDescription ? (
                        <div className="flex gap-2">
                          <Button
                            variant="outline"
                            onClick={() => {
                              setIsEditingDescription(false);
                              setCurrentlyEditing(null);
                            }}
                            disabled={isSavingDescription}
                            className="text-sm"
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="outline"
                            onClick={handleSaveDescription}
                            disabled={isSavingDescription}
                            className="text-sm"
                          >
                            {isSavingDescription ? (
                              <>
                                <i className="fa-solid fa-spinner fa-spin mr-2"></i>
                                Saving...
                              </>
                            ) : (
                              "Save"
                            )}
                          </Button>
                        </div>
                      ) : null}
                    </div>

                    {isEditingDescription ? (
                      <>
                        <textarea
                          value={editableDescription}
                          onChange={(e) => {
                            const normalized = e.target.value.replace(
                              /\s+/g,
                              " "
                            );
                            if (normalized.length <= 350) {
                              setEditableDescription(normalized);
                              setDescriptionError("");
                            } else {
                              setDescriptionError(
                                "Description must be 350 characters or less"
                              );
                            }
                          }}
                          className="w-full p-2 border rounded-md min-h-[100px] text-sm"
                          placeholder="Enter description..."
                          disabled={isSavingDescription}
                        />
                        {descriptionError && (
                          <p className="text-red-500 text-xs mt-1">
                            {descriptionError}
                          </p>
                        )}
                      </>
                    ) : (
                      <p className="text-sm whitespace-pre-line break-all">
                        {data?.ticket_details.description ||
                          "No description provided."}
                      </p>
                    )}
                  </CardContent>
                </Card>

                {/* Comments Section */}
                <div className="space-y-2">
                  <h3 className="font-medium">Comments</h3>
                </div>

                <button
                  className="flex items-center gap-2 text-[#C1554E] text-base font-medium"
                  onClick={() => setShowComments(!showComments)}
                >
                  <i
                    className={`fa-solid  ${showComments ? "fa-angle-up" : "fa-angle-down"}`}
                    style={{ color: "#d9540d" }}
                  ></i>
                  Show Comments
                </button>
                {showComments && (
                  <CommentsSection
                    ticketId={ticketId?.toString() || data?.ticket_details.id.toString() || ""}
                    refetchComments={refetch}
                    ticketData={data?.ticket_details.comments}
                  />
                )}
              </TabsContent>

              {/* Tasks Tab Content */}
              <TabsContent value="tasks">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="font-semibold text-xl">Related Tasks</h2>
                  <Button
                    onClick={handleCreateTask}
                    access={viewkanban !== "read"}
                    variant="default"
                    className="flex items-center gap-2"
                  >
                    <PlusCircle className="h-4 w-4" />
                    Create Task
                  </Button>
                </div>

                <Card className="">
                  <CardContent className="p-4 overflow-x-auto">
                    {tableData && tableData.length > 0 ? (
                      <Table className="pt-3">
                        <TableHeader>
                          <TableRow>
                            <TableHead>Task Name</TableHead>
                            <TableHead>Assigned To</TableHead>
                            <TableHead>Due Date</TableHead>
                            <TableHead>Linked Ticket</TableHead>
                            <TableHead>Status</TableHead>
                            {viewkanban !== "read" && (
                              <TableHead className="w-[100px]">
                                Actions
                              </TableHead>
                            )}
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {tableData.map((task, index) => {
                            const formatValue = (value: any) => {
                              if (Array.isArray(value) && value.length > 0)
                                return value.join(", ");
                              if (
                                value === "()" ||
                                value === "[]" ||
                                value === ""
                              )
                                return "No Data";
                              return value;
                            };

                            return (
                              <TableRow key={index}>
                                <TableCell className="capitalize">
                                  <Tooltip>
                                    <TooltipTrigger>
                                      <p className="capitalize text-nowrap max-w-[150px] truncate overflow-hidden">
                                        {task.title}
                                      </p>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                      {task.title}
                                    </TooltipContent>
                                  </Tooltip>
                                </TableCell>
                                <TableCell className="capitalize">
                                  <Tooltip>
                                    <TooltipTrigger>
                                      <p className="capitalize text-nowrap max-w-[150px] truncate overflow-hidden">
                                        {staffData?.find(
                                          (staff) =>
                                            staff.value === task.assigned_to
                                        )?.label || ""}
                                      </p>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                      {staffData?.find(
                                        (staff) =>
                                          staff.value === task.assigned_to
                                      )?.label || ""}
                                    </TooltipContent>
                                  </Tooltip>
                                </TableCell>
                                <TableCell>
                                  {task.due_date
                                    ? new Date(task.due_date)
                                        .toLocaleDateString("en-PK", {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                        })
                                        .replace(/\//g, "-")
                                    : "No due date"}
                                </TableCell>
                                <TableCell>
                                  {task.linked_ticket?.ticket_number || "N/A"}
                                </TableCell>
                                <TableCell className="capitalize">
                                  <Badge
                                    className={cn(
                                      task.status === TaskStatus.TODO
                                        ? "bg-[#3dc7d1]"
                                        : task.status === TaskStatus.IN_PROGRESS
                                          ? "bg-[#63c82c]"
                                          : task.status === TaskStatus.HOLD
                                            ? "bg-[#ff9429]"
                                            : task.status ===
                                                TaskStatus.COMPLETED
                                              ? "bg-[#1d4a18]"
                                              : task.status ===
                                                  TaskStatus.ARCHIVED
                                                ? "bg-[#cf3040]"
                                                : ""
                                    )}
                                  >
                                    {task.status === TaskStatus.TODO
                                      ? "Pending"
                                      : task.status || "Pending"}{" "}
                                  </Badge>
                                </TableCell>

                                {viewkanban !== "read" && (
                                  <TableCell>
                                    <DataTableRowActions
                                      showLogs={false}
                                      data={task}
                                      refetch={refetch}
                                      handleEdit={handleEditTask}
                                      access={viewkanban}
                                      setTicketId={setTaskLogId}
                                      setOpenLog={setTaskLogsOpen}
                                    />
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    ) : (
                      <p className="text-center py-4">
                        No Related Task available
                      </p>
                    )}
                  </CardContent>
                </Card>
              </TabsContent>

              {/* Linked Tickets Tab Content */}
              <TabsContent value="linked">
                <div className="flex justify-between items-center">
                  <h2 className="pt-2 pb-2 font-semibold text-xl">
                    Linked Tickets
                  </h2>
                  {isEditingAllowed() &&
                    !data?.ticket_details.parent_ticket && (
                      <Button
                        className="gap-2"
                        onClick={() => setIsLinkSheetOpen(true)}
                      >
                        Link Ticket
                        <i className="fas fa-link"></i>
                      </Button>
                    )}
                </div>

                <Card>
                  <CardContent className="p-4 overflow-x-auto">
                    {data?.ticket_details.parent_ticket ||
                    (data?.ticket_details.child_tickets &&
                      data?.ticket_details.child_tickets.length > 0) ? (
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead>Relationship</TableHead>
                            <TableHead>Ticket ID</TableHead>
                            <TableHead>Title</TableHead>
                            <TableHead>Status</TableHead>
                            {/* {isEditingAllowed() && (
                              <TableHead>Actions</TableHead>
                            )} */}
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {data?.ticket_details.parent_ticket && (
                            <TableRow>
                              <TableCell>Parent</TableCell>
                              <TableCell>
                                {data.ticket_details.parent_ticket.ticket_id}
                              </TableCell>
                              <TableCell className="capitalize">
                                <Tooltip>
                                  <TooltipTrigger>
                                    <p className="capitalize text-nowrap max-w-[150px] truncate overflow-hidden">
                                      {data.ticket_details.parent_ticket.title}
                                    </p>
                                  </TooltipTrigger>
                                  <TooltipContent>
                                    {data.ticket_details.parent_ticket.title}
                                  </TooltipContent>
                                </Tooltip>
                              </TableCell>
                              <TableCell>
                                <Badge
                                  className={`${getStatusColor(data.ticket_details.parent_ticket.status)} text-white`}
                                >
                                  {data.ticket_details.parent_ticket.status.replace(
                                    "_",
                                    " "
                                  )}
                                </Badge>
                              </TableCell>
                            </TableRow>
                          )}
                          {data?.ticket_details.child_tickets &&
                            data.ticket_details.child_tickets.length > 0 &&
                            data.ticket_details.child_tickets.map(
                              (childTicket) => (
                                <TableRow key={childTicket.id}>
                                  <TableCell>Linked Ticket</TableCell>
                                  <TableCell>
                                    {childTicket.ticket_id}
                                  </TableCell>
                                  <TableCell className="capitalize">
                                    <Tooltip>
                                      <TooltipTrigger>
                                        <p className="capitalize text-nowrap max-w-[150px] truncate overflow-hidden">
                                          {childTicket.title}
                                        </p>
                                      </TooltipTrigger>
                                      <TooltipContent>
                                        {childTicket.title}
                                      </TooltipContent>
                                    </Tooltip>
                                  </TableCell>
                                  <TableCell>
                                    <Badge
                                      className={`${getStatusColor(childTicket.status)} text-white`}
                                    >
                                      {childTicket.status.replace("_", " ")}
                                    </Badge>
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    ) : (
                      <p className="text-center py-4">
                        No linked tickets available
                      </p>
                    )}
                  </CardContent>
                </Card>
              </TabsContent>

              {/* Logs Tab Content */}
              <TabsContent value="logs">
                <h2 className="pt-2 pb-2 font-semibold text-xl">Logs</h2>
                <Card>
                  <CardContent className="p-4 overflow-x-auto">
                    {data?.history && data.history.length > 0 ? (
                      <Table>
                        <TableHeader>
                          <TableRow>
                            <TableHead>Type</TableHead>
                            <TableHead>Field Name</TableHead>
                            <TableHead>Updated From</TableHead>
                            <TableHead>Updated To</TableHead>
                            <TableHead>Action Date</TableHead>
                            <TableHead>Action By</TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {data.history.map((log, index) => {
                            const formatValue = (value: any) => {
                              if (
                                value === "()" ||
                                value === "[]" ||
                                value === "" ||
                                value == null ||
                                value === "[' ']"
                              ) {
                                return "No Data";
                              }

                              // Try to parse stringified array like "['New Inquiry']"
                              if (
                                typeof value === "string" &&
                                value.startsWith("['") &&
                                value.endsWith("']")
                              ) {
                                try {
                                  const parsed = JSON.parse(
                                    value.replace(/'/g, '"')
                                  );
                                  if (Array.isArray(parsed)) {
                                    const formattedArray = parsed.map((item) =>
                                      typeof item === "string"
                                        ? item.replace(/_/g, " ")
                                        : item
                                    );
                                    return formattedArray.length === 1
                                      ? formattedArray[0]
                                      : formattedArray.join(", ");
                                  }
                                } catch (err) {
                                  // Ignore parsing error and fallback to underscore replacement
                                }
                              }

                              if (typeof value === "string") {
                                return value.replace(/_/g, " ");
                              }

                              if (Array.isArray(value) && value.length > 0) {
                                const formattedArray = value.map((item) =>
                                  typeof item === "string"
                                    ? item.replace(/_/g, " ")
                                    : item
                                );
                                return formattedArray.length === 1
                                  ? formattedArray[0]
                                  : formattedArray.join(", ");
                              }

                              return value;
                            };

                            return (
                              <TableRow key={index}>
                                <TableCell className="capitalize">
                                  {log.type}
                                </TableCell>
                                <TableCell className="capitalize text-nowrap">
                                  {formatValue(log.field_name)}
                                </TableCell>
                                <TableCell className="capitalize">
                                  {formatValue(log.updated_from)}
                                </TableCell>
                                <TableCell className="capitalize">
                                  {formatValue(log.updated_to)}
                                </TableCell>
                                <TableCell>
                                  {new Date(log.action_date)
                                    .toLocaleDateString("en-PK", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    })
                                    .replace(/\//g, "-")}
                                </TableCell>
                                <TableCell className="capitalize">
                                  {log.action_by}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    ) : (
                      <p className="text-center py-4">No logs available</p>
                    )}
                  </CardContent>
                </Card>
              </TabsContent>
            </Tabs>
          </div>
        </SheetContent>
      </Sheet>
      <TicketEditForm
        isOpen={isSheetOpen}
        setOpen={setIsSheetOpen}
        initialData={selectedTicket}
        onSave={handleSaveTicket}
        refetch={refetch}
      />
      {/* <TaskForm
        isOpen={isTaskFormOpen}
        setOpen={setIsTaskFormOpen}
        action={taskFormAction}
        data={selectedTask}
        refetch={refetch}
        isgettingCreate={false}
        selectedTicket={data?.ticket_details}
      /> */}
      <TaskForm
        isOpen={isTaskFormOpen}
        setOpen={setIsTaskFormOpen}
        action={taskFormAction}
        setAction={setTaskFormAction}
        refetch={TaskRefetch}
        data={selectedTask}
        setData={setSelectedTask}
        isgettingCreate={taskFormAction !== "edit"}
        initialTicket={{
          ticket_id: data?.ticket_details?.id?.toString() || "",
          ticket_number: data?.ticket_details?.ticket_id?.toString() || "",
        }}
      />
      <LinkedTickets
        isOpen={isLinkSheetOpen}
        setOpen={setIsLinkSheetOpen}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        tickets={filteredTickets}
        isLoading={isLoadingTickets}
        selectedTicket={selectedLinkTicket}
        setSelectedTicket={setSelectedLinkTicket}
        onSave={linkTicket}
        isTicketLinking={isLinkingTicket}
        loading={false} // Replace with actual loading state if you have one
      />{" "}
    </div>
  );
};

export default DetailLogs;


